import { QueryService } from '@captiveaire/query';
import { Column, IGridView, ITableConfig, TableEventService, TableService } from '@captiveaire/table';
import { ToastService } from '@captiveaire/toast';
import * as _ from 'lodash';
import { deviceStatus, IModuleSummarySearchCriteria } from '@caslink/common-client';
import { IMapPin } from '@caslink/common-client/ng-app/bing-map/typings/models';
import { AppContextService } from '@caslink/common-client/ng-app/appContext/AppContextService';
import { JobNumberPopupService } from '@caslink/common-client/ng-app/jobNumberPopup/JobNumberPopupService';
import { ModuleViewNavigationService } from '@caslink/common-client/ng-app/moduleViewNavigationService/ModuleViewNavigationService';
import { AfterViewInit, Component, DoCheck, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CommonBroadcastService } from '@caslink/common-client/ng-app/common-broadcast/common-broadcast.service';
import { DialogService } from '@caslink/common-client/ng-app/dialog-service/dialog.service';
import { FormatHardwareVersionPipe } from '@caslink/device-client/ng-app/shared/pipes/format-hardware-version.pipe';
import { ModbusService } from '@caslink/common-client/ng-app/modbus/ModbusService';
import { ModuleSummaryService } from '@caslink/common-client/ng-app/moduleSummary/ModuleSummaryService';
import { EventTypes } from '@caslink/common-client/src';
import { StateService } from '@uirouter/core';
import { IDeviceStatusListSearchCriteria } from '../shared/models/device-status-list-search-criteria.interface';
import { IDeviceStatusListSummary } from '../shared/models/device-status-list-summary.interface';
import { IDeviceStatusBulkTemplateUpdateResult } from '../shared/models/models';
import { DeviceBulkOperationComponent, DeviceBulkOperationDialogData } from '../device-bulk-operation/device-bulk-operation.component';
import { DeviceFirmwareUpdateBulkComponent } from '../device-firmware-update-bulk/device-firmware-update-bulk.component';
import { DeviceMenuItemsService } from '../shared/services/device-menu-items.service';
import { DeviceStatusService } from '../shared/services/device-status.service';
import { DeviceStatusViewBaseComponent } from '../shared/components/device-status-view-base.component';
import { DeviceStatusTableCellComponent } from '../device-status-table-cell/device-status-table-cell.component';
// tslint:disable-next-line: max-line-length
import { DeviceStatusConfigurationCellComponent } from '../device-status-configuration-cell/device-status-configuration-cell.component';
import { DeviceStatusExpandRowComponent } from '../device-status-expand-row/device-status-expand-row.component';
import { DeviceStatusFiltersHandler } from '../shared/services/device-status-filter-handler.service';
import { DeviceStatusFirmwareVersionCellComponent } from '../device-status-firmware-version-cell/device-status-firmware-version-cell.component';
import { DeviceStatusMacCellComponent } from '../device-status-mac-cell/device-status-mac-cell.component';
import { DeviceStatusModbusIdCellComponent } from '../device-status-modbus-id-cell/device-status-modbus-id-cell.component';
import { DeviceStatusVersionCellComponent } from '../device-status-version-cell/device-status-version-cell.component';
import { DeviceStatusViewInfoQueryService } from '../shared/services/device-status-view-info-query.service';
import { DeviceStatusViewInfoService } from '../shared/services/device-status-view-info.service';
import { Subscription } from 'rxjs';
import { ThemeService } from '@caslink/common-client/ng-app/theme/ThemeService';

@Component({
    selector: 'dl-device-status-grid',
    styles: [
        `
        :host advanced-dropdown,
        :host mat-form-field {
          margin-right: 6px;
        }
        .text-color-white {
            color: white;
        }
        `
    ],
    templateUrl: './device-status-grid.component.html'
})
export class DeviceStatusGridComponent extends DeviceStatusViewBaseComponent implements AfterViewInit, DoCheck, OnInit, OnDestroy, IGridView {
    public static $name: string = 'deviceStatusGrid';

    @Input() public isMapEnabled: boolean;
    @Input() public jobNumber: number = null;
    @Input() public locationId: number = null;
    @Input() public moduleId: number = null;

    public data: IDeviceStatusListSummary[];
    public query: IDeviceStatusListSearchCriteria;
    public tableConfig: ITableConfig;
    public hardwareCategory: string = null;

    public currentItem: IDeviceStatusListSummary;
    public currentItemState: IDeviceStatusListSummary;

    public ignoreForm: boolean = true;

    public canUpdateFirmwareVersion: boolean = false;
    public deviceStatusFormGroup: FormGroup;
    public wildcardFormControl: FormControl;
    public jobNumberFormControl: FormControl;
    public isCertifiedFormControl: FormControl;
    public isAirQualityExcellenceFormControl: FormControl;

    public isReady: boolean = false;

    // true if location and module dropdowns will not be shown
    hideFields: boolean;
    wizardView: boolean;

    pins: IMapPin[];
    defaultMapHeight: number;

    public get isFilterActive(): boolean {
        return this.query.hardwareCategory != null &&
            this.query.hardwareCategory.length > 0;
    }

    private previousHardwareVersion: number;
    private _search: (updatePins?: boolean, resolve?: any) => void;
    private deviceStatusGridSubscriptions: Subscription;

    constructor(
        private $state: StateService,
        public dialog: MatDialog,
        public dialogService: DialogService,
        public appContextService: AppContextService,
        public deviceStatusService: DeviceStatusService,
        private moduleSummaryService: ModuleSummaryService,
        private queryService: QueryService,
        private tableService: TableService,
        private toastService: ToastService,
        private modbusService: ModbusService,
        private moduleViewNavigationService: ModuleViewNavigationService,
        private deviceStatusViewInfoService: DeviceStatusViewInfoService,
        private deviceStatusViewInfoQueryService: DeviceStatusViewInfoQueryService,
        public deviceStatusFilters: DeviceStatusFiltersHandler,
        private deviceMenuItemsFactory: DeviceMenuItemsService,
        private jobNumberPopupService: JobNumberPopupService,
        private commonBroadcastService: CommonBroadcastService,
        private elementRef: ElementRef,
        private hardwareVersionPipe: FormatHardwareVersionPipe,
        private tableEventService: TableEventService,
        private themeService: ThemeService
    ) {
        super();
    }

    public ngAfterViewInit() {
        setTimeout(() => this.isReady = true);
    }

    public ngDoCheck() {
        if (this.currentItem) {
            let currentHardwareVersion = this.currentItem.hardwareVersion;

            if (this.previousHardwareVersion !== currentHardwareVersion) {
                this.modbusService.updateConfigurations(this.currentItem.macAddress, this.currentItem, this.currentItemState, currentHardwareVersion);
                this.previousHardwareVersion = currentHardwareVersion;
            }
        }
    }

    public ngOnInit() {
        const defaultMultiplier = 0.5;
        this.defaultMapHeight = (this.elementRef.nativeElement as HTMLElement).parentElement.clientHeight * defaultMultiplier;
        this.setPermission();
        this.initGrid();
        this.initDropdowns();
        this.subscribeToEvents();

        this.deviceStatusFormGroup = new FormGroup({});
        this.wildcardFormControl = new FormControl(this.query.wildcard);
        this.jobNumberFormControl = new FormControl(this.query.jobNumber);
        this.isCertifiedFormControl = new FormControl(this.query.isCertified);
        this.isAirQualityExcellenceFormControl = new FormControl(this.query.isAirQualityExcellence);
        this.deviceStatusFormGroup.addControl('wildcard', this.wildcardFormControl);
        this.deviceStatusFormGroup.addControl('jobNumber', this.jobNumberFormControl);
    }

    public ngOnDestroy() {
        if (this.deviceStatusGridSubscriptions) { this.deviceStatusGridSubscriptions.unsubscribe(); }
        this.deviceStatusViewInfoQueryService.setQuery(this.query);
        this.deviceStatusService.stopStatusUpdates(this.loadedLocationId, this.data, this.locationId);
    }

    public search(updatePins: boolean = true) {
        return new Promise((resolve) => {
            if (!this._search) {
                this._search = _.debounce((pins, promiseResolve) => {
                    this.query.wildcard = this.wildcardFormControl.value;
                    this.query.jobNumber = this.jobNumberFormControl.value;
                    this.query.isCertified = this.isCertifiedFormControl.value;
                    this.query.isAirQualityExcellence = this.isAirQualityExcellenceFormControl.value;

                    if (pins) {
                        this.updatePins(this.query);
                    }
                    this.tableEventService.updateEvent.emit({ $$consumed: false });
                    promiseResolve();
                    // tslint:disable-next-line: no-magic-numbers
                }, 500);
            }
            this._search(updatePins, resolve);
        });
    }

    public getData(): angular.IPromise<any> {
        return this.deviceStatusService.getList(this.query)
            .then(response => {
                if (this.data) {
                    this.deviceStatusService.stopStatusUpdates(this.loadedLocationId, this.data, this.locationId);
                }
                this.data = response.items;
                this.query.totalObjects = response.totalCount ? response.totalCount : this.query.totalObjects;
                this.deviceStatusService.startStatusUpdates(this.loadedLocationId, this.data, this.locationId);
            })
            .catch(() => this.toastService.showSimple('Internal Error'));
    }

    public viewDetail(item: IDeviceStatusListSummary) {
        this.moduleViewNavigationService.viewHardwareItem(
            item.hardwareItem.id,
            item.locationId,
            item.hardwareItem.moduleId,
            item.macAddress,
            this.query);
    }

    public editDeviceConfiguration(item: IDeviceStatusListSummary) {
        item.$isInEditMode = !item.$isInEditMode;

        if (this.currentItem) {
            this.cancelEdit(this.currentItem);
        }

        item.$isInEditMode = true;
        const query: IModuleSummarySearchCriteria =
            _.cloneDeep(this.deviceStatusFilters.modules.query) as IModuleSummarySearchCriteria;
        query.locationId = item.locationId;
        this.moduleSummaryService.getList(query).then(items => {
            item.macAddresses = items.items;
        });
        this.currentItem = item;
        this.currentItemState = { ...item };
    }

    public categoryHandler($event) {
        this.deviceStatusFilters.categories.selected = $event;

        const selected = (this.deviceStatusFilters.categories.selected != null) ?
            this.deviceStatusFilters.categories.selected : null;

        this.query.hardwareCategory = (selected != null) ? selected.type : null;
        this.query.hardwareCategoryId = (selected != null) ? selected.id : null;

        if (this.query.hardwareCategory !== null) {
            this.deviceStatusService
                .canUpdateFirmwareVersion(this.query.hardwareCategory)
                .then(result => {
                    this.canUpdateFirmwareVersion = result;
                });
        }

        this.search();
    }

    public viewJson(item: IDeviceStatusListSummary) {
        this.$state.go(deviceStatus.deviceJsonViewer, {
            category: item.category,
            hardwareItemId: item.hardwareItem.id,
            query: this.query
        });
    }

    public changeTemplateVersion($event, items) {
        this.dialog.open(DeviceBulkOperationComponent, {
            data: {
                hardwareCategory: this.query.hardwareCategory
            } as DeviceBulkOperationDialogData
        }).afterClosed()
            .toPromise()
            .then((result: IDeviceStatusBulkTemplateUpdateResult) => {
                if (result) {
                    this.deviceStatusService.setTemplateVersion(this.query, result)
                        .then(() => {
                            this.search();
                        });
                }
            });
    }

    public updateFirmwareVersion($event) {
        this.dialog.open(DeviceFirmwareUpdateBulkComponent, {
            data: {
                hardwareCategory: this.query.hardwareCategory
            } as DeviceBulkOperationDialogData
        }).afterClosed()
            .toPromise()
            .then((result: string) => {
                if (result) {
                    this.deviceStatusService.updateFirmwareVersion(this.query, result)
                        .then(() => {
                            this.search();
                        });
                }
            });
    }

    public exportToXlsx() {
        const customQuery: IDeviceStatusListSearchCriteria =
            _.cloneDeep(this.query) as IDeviceStatusListSearchCriteria;
        customQuery.limit = this.query.totalObjects;
        customQuery.page = 1;
        this.deviceStatusService.getList(customQuery)
            .then(response => {
                const mappedItems = [];
                for (const item of response.items) {
                    const newItem = {};
                    for (const column of this.getColumns()) {
                        if (column.component) {
                            switch (column.component) {
                                case DeviceStatusMacCellComponent:
                                    newItem[column.name] = item.moduleDescription;
                                    break;
                                case DeviceStatusVersionCellComponent:
                                    newItem[column.name] = item.hardwareVersion ?
                                        this.hardwareVersionPipe.transform(item.hardwareVersion.toString()) : '';
                                    break;
                                case DeviceStatusConfigurationCellComponent:
                                    newItem[column.name] = item.configuration ? item.configuration.Value : '';
                                    break;
                                case DeviceStatusModbusIdCellComponent:
                                    newItem[column.name] = item.modbusId;
                                    break;
                                case DeviceStatusTableCellComponent:
                                    newItem[column.name] = this.deviceStatusViewInfoService
                                        .getState(item.deviceStatusType, false).statusDescription;
                                    break;
                                case DeviceStatusFirmwareVersionCellComponent:
                                    newItem[column.name] = item.embeddedVersion ?
                                        this.hardwareVersionPipe.transform(item.embeddedVersion.toString()) : '';
                                    break;
                                default:
                                    newItem[column.name] = 'n/a';
                                    break;
                            }
                        } else {
                            newItem[column.name] = item[column.property];
                        }
                    }
                    mappedItems.push(newItem);
                }

                const XLSX = window['XLSX'];
                const ws = XLSX.utils.json_to_sheet(mappedItems);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Devices');
                XLSX.writeFile(wb, 'devices.xlsx');
            })
            .catch(() => this.toastService.showSimple('Internal Error'));
    }


    private onPinClick($event: CASLink.Device.Ui.ViewModel.Modules.LocationPinSearchResultViewModel) {
        if (this.query.locationId !== $event.locationId) {
            this.query.pinLocationId = $event.locationId;
            this.search(false).then(() => {
                this.query.pinLocationId = null;
            });
        }
    }

    private onInfoboxClosed() {
        this.search(false);
    }

    // Temporary override default behavior until we get rid of global styles.
    // Some global css was changing the text color to black in dark mode.
    isDarkTheme() {
        return this.themeService.getTheme() === 'casDark';
    }

    private initDropdowns() {
        this.deviceStatusFilters.init(this.query, () => this.search());

        this.deviceStatusFilters.initDropdowns(this.wizardView, this.hideFields);
    }

    private subscribeToEvents() {
        this.deviceStatusGridSubscriptions = new Subscription();

        const deviceStatusUpdateSubscription = this.commonBroadcastService.on(EventTypes.DeviceStatusUpdate)
            .subscribe((data: IDeviceStatusListSummary) => {
                this.deviceStatusService.deviceStatusUpdate(this.data, data);
            });

        const mapPinSubscription = this.commonBroadcastService.on(EventTypes.OnMapPinClick)
            .subscribe(metadata => this.onPinClick(metadata));

        const infoboxCloseSubscription = this.commonBroadcastService.on(EventTypes.OnInfoboxClosed)
            .subscribe(() => this.onInfoboxClosed());

        this.deviceStatusGridSubscriptions.add(deviceStatusUpdateSubscription);
        this.deviceStatusGridSubscriptions.add(mapPinSubscription);
        this.deviceStatusGridSubscriptions.add(infoboxCloseSubscription);

    }

    private setPermission() {
        if (this.moduleId) {
            this.hideFields = true;
        }
        this.locationId = this.locationId === null && this.jobNumber == null ? this.loadedLocationId : this.locationId;
        this.moduleId = this.moduleId === null ? this.appContextService.loadedModuleId : this.moduleId;
    }

    private initGrid() {
        const loadLimit = 10;
        this.query = this.deviceStatusViewInfoQueryService.getQuery();

        if (this.query == null) {
            this.query = this.queryService.createQuery(loadLimit, 'Id', 1, true);
            this.query.includeTotalCount = true;

            this.query.locationId = this.locationId === 0 ? null : this.locationId;
            this.query.moduleId = this.moduleId === 0 ? null : this.moduleId;
            this.query.jobNumber = this.jobNumber ? this.jobNumber : null;
        }

        this.updatePins(this.query);

        this.tableConfig = {
            columns: this.getColumns(),
            contextMenu: this.deviceMenuItemsFactory.getMenuItems(this),
            expandComponent: DeviceStatusExpandRowComponent,
            expandWithoutFirstColumn: true,
            query: this.query,
            showEditColumn: true,
            smallerFont: true
        };
    }

    private getColumns(): any {
        const result = [];
        result.push(this.getDeviceStatusColumn());
        result.push(this.getColumn('Location', 'location'));
        result.push(this.getMacColumn());
        result.push(this.getColumn('Device Type', 'category'));
        result.push(this.getColumn('Device', 'tag'));
        result.push(this.getColumn('Sequence', 'sequence'));
        result.push(this.getFirmwareVersionColumn());
        result.push(this.getColumn('Job Number', 'jobNumber', false));
        result.push(this.getHardwareVersionColumn());
        result.push(this.getConfigurationColumn());
        result.push(this.getModbusIdColumn());
        return result;
    }

    private getFirmwareVersionColumn(): Column {
        const column = this.tableService.createColumn('Firmware Version', '', false);
        column.component = DeviceStatusFirmwareVersionCellComponent;
        column.smallerHeader = true;
        return column;
    }

    private getMacColumn(): Column {
        const column = this.tableService.createColumn('Module', '', false);
        column.component = DeviceStatusMacCellComponent;
        column.smallerHeader = true;
        return column;
    }

    private getConfigurationColumn(): Column {
        const column = this.tableService.createColumn('Configuration', '', false);
        column.component = DeviceStatusConfigurationCellComponent;
        column.smallerHeader = true;
        return column;
    }

    private getModbusIdColumn(): Column {
        const column = this.tableService.createColumn('Modbus Id', '', false);
        column.component = DeviceStatusModbusIdCellComponent;
        column.smallerHeader = true;
        return column;
    }

    private getDeviceStatusColumn(): Column {
        const column = this.tableService.createColumn('', '', false);
        column.component = DeviceStatusTableCellComponent;
        column.smallerHeader = true;
        return column;
    }

    private getHardwareVersionColumn(): Column {
        const column = this.tableService.createColumn('Template Version', '', false);
        column.component = DeviceStatusVersionCellComponent;
        column.smallerHeader = true;
        return column;
    }

    private getColumn(title: string, label: string, sortable: boolean = true): Column {
        const column = this.tableService.createColumn(title, label, sortable);
        column.smallerHeader = true;
        return column;
    }

    private viewActions(item: IDeviceStatusListSummary, $event) {
        $event.stopPropagation();
        $event.preventDefault();
        item.$expanded = !item.$expanded;
    }

    private updatePins(query) {
        this.deviceStatusService.getPins(query).then(pins => {
            this.pins = pins.map(pushpin => ({
                detail: `<table><tr><td><label class="bold">Address</label></td><td>${pushpin.address}</td></tr></table>`,
                latitude: pushpin.latitude,
                location: pushpin.location,
                locationId: pushpin.locationId,
                longitude: pushpin.longitude,
            }) as IMapPin);
            this.commonBroadcastService.broadcast(EventTypes.PinsUpdated, this.pins);
        });
    }
}
